module.exports = __webpack_public_path__ + "img/c5aad2c.svg";